export default __webpack_public_path__ + "static/media/logo.bceb4916.png";